import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Dialog,
  Grid,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  styled,
  FormControl,
  MenuItem,
  Select,
} from "@mui/material";
import ConfirmationPopup from "./ConfirmationPopup";
import DoneDialog from "./DoneDialog";
import DoneDialogDuplicate from "./DoneDialogDuplicate";
import { getRequest } from "../../Services/AxiosConfiguration";
import {
  API_BASE_URL,
  CGO_SCENARIO_GET_API,
  // DISPLAY_FOLDER_LIST_BY_USECASE_API,
  DISPLAY_FOLDER_LIST_BY_USECASE_AND_USERID_API,
  DISPLAY_SCENARIO_FILTER_API,
  GET_DUPLICATE_COG_SCENARIO_API,
  GET_DUPLICATE_LT_SCENARIO_API,
  GET_DUPLICATE_SCENARIO_API,
  LT_DISPLAY_SCENARIO_FILTER_API,
} from "../../Utils/Config";
import {
  displayFolderList,
  displayFolderListError,
  displayFolderListSuccess,
  displayScenarioList,
  displayScenarioListError,
  displayScenarioListSuccess,
  isDuplicateScenarioCreated,
  openErrorDialog,
} from "../../Redux/Actions/InputData";
import ToastPopup from "../ToastPopup";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function DuplicateScenario(props: any) {
  const dispatch = useDispatch();
  const [isDone, setIsDone] = useState(false);
  const [selectFolder, setSelectFolder] = useState<any>("Select Folder");
  const [selectScenario, setSelectScenario] = useState<any>("Select Scenario");
  const [selectFolderId, setSelectFolderId] = useState<any>("Select Folder");
  const [selectScenarioId, setSelectScenarioId] =
    useState<any>("Select Scenario");
  const [folderOptions, setFolderOptions] = useState<any>(props.folderItems);
  const [scenarioOptions, setScenarioOptions] = useState<any>([]);
  const [buttonText, setButtonText] = useState<any>("DUPLICATE AND RENAME");
  const [isDisabled, setIsDisabled] = useState<any>(false);

  const [isOpenduplicateConfirmation, setIsOpenduplicateConfirmation] =
    useState<any>(false);
  const [isFailed, seIsFailed] = useState<any>(false);
  const [errorMsg, setErrorMsg] = useState<any>();
  let sc = localStorage.getItem("selectedUsecase");
  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId
  );
  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId
  );
  const [inputFolderName, setInputFolderName] = useState();
  const handleInputFolderName = (event: any) => {
    setInputFolderName(event.target.value);
  };
  const isCompleted = useSelector(
    (state: any) => state.InputDataReducers.isDone
  );
  const userData = useSelector(
    (state: any) => state.InputDataReducers.apiUserData
  );
  console.log(userData, "userData");

  useEffect(() => {
    console.log(props.folderItems, "-----------------props.folderItems");
    //folderListApi();
  }, [selectedUsecaseId, selectedCategoryId]);

  const handleDuplicateAndRename = (e: any) => {
    seIsFailed(false);
    setIsDisabled(true);
    setButtonText("Processing ...");
    if (
      inputFolderName !== undefined &&
      inputFolderName !== "" &&
      selectFolderId !== undefined &&
      selectFolderId !== 0 &&
      selectScenarioId !== undefined &&
      selectScenarioId !== 0
    ) {
      const apiURL =
        sc === "COG"
          ? GET_DUPLICATE_COG_SCENARIO_API
          : sc === "Long Term Analysis"
          ? GET_DUPLICATE_LT_SCENARIO_API
          : GET_DUPLICATE_SCENARIO_API;
      const urls = API_BASE_URL + apiURL;
      const header = {
        accept: "application/json",
        "Content-Type": "application/json",
      };

      let duplicateCheckObj = {
        useCaseId:
          sc === "COG" || sc === "Long Term Analysis" ? 0 : props.useCaseId,
        categoryId:
          sc === "COG" || sc === "Long Term Analysis" ? 0 : props.categoryId,
        folderId: selectFolderId,
        scenarioId: selectScenarioId,
        destScenario: inputFolderName,
      };
      if (sc === "Long Term Analysis") {
        let splidFolder = selectFolder.slice(0, 7);
        let duplicateObj = { modulekey: splidFolder };
        let combineObj = { ...duplicateCheckObj, ...duplicateObj };
        duplicateCheckObj = combineObj;
      }

      getRequest(urls, duplicateCheckObj, header)
        .then((response) => {
          setIsDisabled(false);
          setButtonText("DUPLICATE AND RENAME");
          if (response.status === 200 && response.data.success) {
            seIsFailed(false);
            setErrorMsg("");
            dispatch(isDuplicateScenarioCreated(true));
            setIsDone(true);
            //props.cancelDuplicate(false);
          } else {
            seIsFailed(true);
            setErrorMsg(response?.data?.message);
          }
        })
        .catch((error) => {
          dispatch(openErrorDialog(error));
          dispatch(displayFolderListError(error.message));
        });
    }
  };

  const closeDone = () => {
    setIsDone(false);
    props.cancelDuplicate(false);
  };

  const openConfirmation = () => {
    props.cancelDuplicate(false);
    // setIsOpenduplicateConfirmation(true);
  };

  const handleGoBackToPrevious = () => {
    setIsOpenduplicateConfirmation(false);
  };

  const discardDuplicate = () => {
    props.cancelDuplicate(false);
  };

  const handleChangeSelectFolder = (e: any) => {
    const {
      target: { value },
    } = e;
    setSelectFolder(value.folder);
    setSelectFolderId(value.id);
    //dispatch(selectedFolderListSuccess(value));
    scenarioListApi(value);
  };

  const handleChangeSelectScenario = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectScenario(value.scenario);
    setSelectScenarioId(value.scenario_id);
    //dispatch(selectedScenarioListSuccess(value));
  };

  const folderListApi = () => {
    dispatch(displayFolderList());
    //const urls = API_BASE_URL + DISPLAY_FOLDER_LIST_API;
    const urls = API_BASE_URL + DISPLAY_FOLDER_LIST_BY_USECASE_AND_USERID_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      {
        useCase: selectedUsecaseId,
        category: selectedCategoryId,
        createdBy: userData.userId,
      },
      header
    )
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          setFolderOptions(response.data.data);
          dispatch(displayFolderListSuccess(response.data.data));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(displayFolderListError(error.message));
      });
  };

  // console.log(sc, "coggggg");
  const scenarioListApi = (params: any) => {
    console.log("Tab5");
    dispatch(displayScenarioList());
    const apiURL =
      sc === "COG"
        ? CGO_SCENARIO_GET_API
        : sc === "Long Term Analysis"
        ? LT_DISPLAY_SCENARIO_FILTER_API
        : DISPLAY_SCENARIO_FILTER_API;
    const urls = API_BASE_URL + apiURL;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    getRequest(
      urls,
      { folder_id: params.id, createdBy: userData.userId },
      header
    )
      .then((response) => {
        if (response.status === 200 && response.data) {
          // let responseArray = [];
          // responseArray.push(response.data);
          // setScenarioOptions(responseArray);
          setScenarioOptions(response.data);
          dispatch(displayScenarioListSuccess(response.data));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(displayScenarioListError(error.message));
      });
  };

  return (
    <>
      {isDone && (
        <DoneDialogDuplicate
          handleCloseDonePopup={closeDone}
          isOpenDone={isDone}
        />
      )}
      {isOpenduplicateConfirmation && (
        <ConfirmationPopup
          message="Are you sure want to cancel Scenario duplication?"
          handleGoBackToPrevious={handleGoBackToPrevious}
          discardDuplicate={discardDuplicate}
          isOpen={isOpenduplicateConfirmation}
        />
      )}
      <BootstrapDialog
        onClose={props.cancelDuplicate}
        aria-labelledby="customized-dialog-title"
        open={props.isOpen}
      >
        <div className="modal-header-duplicate">
          <Grid container spacing={1}>
            <Grid item xs={12} md={12} lg={12}>
              <h3>{"Create a scenario by duplication"}</h3>
              <p className="sub-title-text1">
                {"Duplicate a scenario and optimise it."}
              </p>
            </Grid>
            {/* <Grid item xs={2} md={2} lg={2}>
              <CancelIcon className="cancel-icon" onClick={props.closeModal} />
            </Grid> */}
          </Grid>
        </div>
        <DialogContent className="modal-body">
          <div className="create-folder">
            <FormControl fullWidth>
              {/* <label className="select-folder-dropdown">Select Folder*</label>*/}
              <label>Select Folder*</label>
              <Select
                id="select-folder"
                value={selectFolder}
                placeholder="Select Folder"
                onChange={handleChangeSelectFolder}
                renderValue={(selected: any) => selected}
                className="select-folder-field"
              >
                {folderOptions.map((d: any) => {
                  return (
                    <MenuItem key={d.folder_id} value={d}>
                      {sc === "Short Term" || sc === "Medium Term"
                        ? d.folder + "(" + d.time_period + ")"
                        : d.folder}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <br />
            <FormControl fullWidth>
              <label>Select Scenario*</label>
              <Select
                id="select-Scenario"
                value={selectScenario}
                placeholder="Select Scenario"
                onChange={handleChangeSelectScenario}
                renderValue={(selected: any) => selected}
                className="select-folder-field"
              >
                {scenarioOptions.map((d: any) => {
                  return (
                    <MenuItem key={d.scenario_id} value={d}>
                      {d.scenario}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <br />
            <FormControl fullWidth>
              <label>Rename selected Scenario*</label>
              {/* <TextField id="outlined-basic" placeholder="Rename selected scenario" className="create-folder-text" variant="outlined" /> */}
              <TextField
                id="outlined-basic"
                placeholder="Enter Scenario name"
                // className="create-folder-text"
                variant="outlined"
                value={inputFolderName}
                onChange={handleInputFolderName}
                className="rename-selected-input"
              />
            </FormControl>
          </div>
        </DialogContent>
        {isFailed && <ToastPopup message={errorMsg} type="error" />}
        <DialogActions>
          <div className="modal-action">
            <Button
              variant="outlined"
              className="cancel"
              onClick={openConfirmation}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              disabled={isDisabled}
              className="Next"
              onClick={handleDuplicateAndRename}
            >
              {buttonText}
            </Button>
          </div>
        </DialogActions>
      </BootstrapDialog>
    </>
  );
}

export default DuplicateScenario;
function callScenarioFilterApi(value: any) {
  throw new Error("Function not implemented.");
}
